import React from 'react';
import {connect} from 'react-redux';

class TauntTextbox extends React.Component {
  render() {
    const {vW, arenaTaunt} = this.props;

    if (!arenaTaunt) {
      return null; //No arena taunt is set!
    }

    const style = {
      fontSize: this.props.viewportMode === "landscape" ? vW : vW * 2, //desktop, mobile
      position: "absolute",
      zIndex: 10,
      left: "0",
      top: "0",
      padding: "1em",
      background: "#200535",
      color: "#fcfcfc"
    };
    return (
      <div style={style}>
        {arenaTaunt}
      </div>
    )
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode,
    arenaTaunt: state.battle.arenaTaunt
  }
})(TauntTextbox)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/TauntTextbox.js